<template>
  <button
    :class="classes"
    @click.prevent="$emit('clicked')"
    @mouseover="mouseover"
    @mouseout="mouseout"
    @mouseup="mouseout"
  >
    {{ caption }}
  </button>
</template>
<script>
export default {
  name: "Button",
  props: {
    caption: {
      type: String,
      required: true
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: val => ["big", "small"].includes(val)
    },
    type: {
      type: String,
      validator: val => ["primary", "secondary"].includes(val)
    }
  },
  computed: {
    classes: function() {
      let result = "custom-button link--btn";
      this.type && (result += ` ${this.type}`);
      this.size && (result += ` ${this.size}`);
      this.uppercase && (result += " uppercase");
      return result;
    }
  },
  methods: {
    mouseover: function(e) {
      e && e.currentTarget.classList.add("hover");
    },
    mouseout: function(e) {
      e && e.currentTarget.classList.remove("hover");
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-button {
  background: #fff;
  padding: 7px;
  color: #2c255e;
  border-radius: 30px;
  cursor: pointer;
  display: inline-flex;
  user-select: none;
  font-family: "Montserrat", sans-serif;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.16);
  border: none;
  text-transform: none;
  font-weight: normal;

  &:focus {
    outline: 0;
  }
}

.primary {
  background-color: $color-primary;
  color: $color-white;
}

.big {
  letter-spacing: 3px;
  padding: 17px 60px;
  font-size: 19px;
  font-weight: 700;
}

.uppercase {
  text-transform: uppercase;
}
</style>